import { render, staticRenderFns } from "./YoutubeSvg.vue?vue&type=template&id=30013e5c&"
import script from "./YoutubeSvg.vue?vue&type=script&lang=js&"
export * from "./YoutubeSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports